import StoreUser from "GlobalStores/User/StoreUser"
import { toJS } from "mobx"

const useProfile = () => {
    return StoreUser
}

export default useProfile
